/**
 * Story SF-CHAT-9.2 (revisão): links de login nas mensagens do assistente.
 *
 * O botão "fazer login" só nasce para uma URL da **origem do próprio app**
 * (esquema, host e porta iguais), sem credencial embutida, com `token` e
 * `session`. Qualquer outra — inclusive uma induzida por injeção nos dados
 * numa resposta de LLM — fica como texto comum, nunca como botão.
 */

const CANDIDATE = /https?:\/\/[^\s)]+/gi;

export function isTrustedLoginUrl(raw: string, allowedOrigin: string): boolean {
  if (!allowedOrigin) return false;
  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    return false;
  }
  if (url.protocol !== "http:" && url.protocol !== "https:") return false;
  if (url.username || url.password) return false;
  if (url.origin !== allowedOrigin) return false;
  if (!url.pathname.endsWith("/login")) return false;
  const token = url.searchParams.get("token");
  const session = url.searchParams.get("session");
  return Boolean(token && /^[a-f0-9-]+$/i.test(token) && session && /^[a-f0-9-]+$/i.test(session));
}

/** URLs confiáveis de login no texto; uma URL colada numa palavra não conta. */
export function trustedLoginUrls(text: string, allowedOrigin: string): string[] {
  const found: string[] = [];
  for (const match of text.matchAll(CANDIDATE)) {
    const start = match.index ?? 0;
    // Colada numa palavra ("xhttps://…"): não é um link que o app emitiu.
    if (start > 0 && /\S/.test(text[start - 1])) continue;
    if (isTrustedLoginUrl(match[0], allowedOrigin)) found.push(match[0]);
  }
  return found;
}
